import React, {useState} from 'react';
import {VectorMap} from "@south-paw/react-vector-maps";
import {useWorldMap} from "./useWorldMap";
import { Fade, Paper, Popper, Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    root: {
        '& svg': {
            stroke: "fff",
            '& path': {
                fill: theme.palette.grey[300],
                outline: "none",
                '&[aria-current="true"]': {
                    fill: theme.palette.primary.main
                }
            }
        }
    },
    paper: {
        padding: theme.spacing(2)
    }

}))

export const WorldMap = ({data, lowRes = false}) => {
    const classes = useStyles();
    const worldMapResponse = useWorldMap(lowRes);
    const [anchorEl, setAnchorEl] = useState(null);

    const popperContent = () => {
        const country = Boolean(anchorEl) && data.find(row => row.id === anchorEl.attributes.id.value)
        if(country) {
            return (
                <Typography>
                    {country.label}: {country.value}
                </Typography>
            )
        } else {
            return null;
        }
    }

    if (worldMapResponse.error) {
        return <div>Error loading mapdata.</div>
    } else if (worldMapResponse.jsonMap) {
        return (
            <div className={classes.root}>
                <VectorMap
                    {...worldMapResponse.jsonMap}
                    currentLayers={data.map(row => row.id)}
                    layerProps={{
                        onMouseEnter: ({target}) => setAnchorEl(target),
                        onMouseLeave: () => setAnchorEl('')
                    }}
                />
                <Popper
                    id={anchorEl ? anchorEl.attributes.id.value : undefined}
                    open={Boolean(anchorEl) && Boolean(data.find(row => row.id === anchorEl.attributes.id.value))}
                    anchorEl={anchorEl}
                    placement={"top"}
                    transition
                >
                    {({TransitionProps}) => (
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper className={classes.paper}>
                                {popperContent()}
                            </Paper>
                        </Fade>
                    )}
                </Popper>
            </div>
        )
    } else {
        return null;
    }

}